import React from 'react';

export const StringssgMap = () => {
  return (
    <div className="w-full max-w-md mx-auto aspect-video rounded-xl overflow-hidden shadow-lg">
      <iframe
        title="StringsSG Office Location"
        aria-label="Google Map showing StringsSG address"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7616170232427!2d103.89308729999999!3d1.3187036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1818677e43ff%3A0x9053328cc088d24b!2s60%20Paya%20Lebar%20Rd%2C%20Paya%20Lebar%20Square%2C%20Singapore%20409051!5e0!3m2!1sen!2ssg!4v1757319221825!5m2!1sen!2ssg"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};
